"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M9.5 14c0 1.38 1.12 2.5 2.5 2.5 1.23 0 2.25-.9 2.46-2.07-1-1.01-1.83-1.98-2.48-2.93-1.37.02-2.48 1.13-2.48 2.5"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M18.65 17.08c-.37.32-.92.32-1.3 0-1.26-1.08-.7-.61-1.3-1.14-.83 1.74-2.73 2.87-4.85 2.5-1.83-.32-3.31-1.8-3.63-3.63-.42-2.44 1.13-4.58 3.31-5.14C10.3 8.45 10 7.28 10 6.15c0-.75.1-1.47.28-2.15h-.4c-.56 0-1.1.24-1.48.65L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-6.03c-1.41 1.49-2.65 2.51-3.35 3.11"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M17.34 14.42c.37.33.95.33 1.33 0C22.22 11.25 24 8.5 24 6.15 24 2.42 21.15 0 18 0s-6 2.42-6 6.15c0 2.35 1.78 5.1 5.34 8.27m-.07-9.17L18 3l.73 2.25H21l-1.85 1.47.7 2.28L18 7.59 16.15 9l.7-2.28L15 5.25z"
}, "2")], 'LocalSeeRounded');